import apiConfig from '../../config/api.config';

const envs = (isServer: boolean) => {
  return {
    configApi: isServer ? apiConfig.CONFIG_API_URL_SERVER : apiConfig.CONFIG_API_URL,
    feedApi: isServer ? apiConfig.FEED_API_URL_SERVER : apiConfig.FEED_API_URL,
    contentApiV3: isServer ? apiConfig.CONTENT_API_URL_V3_SERVER : apiConfig.CONTENT_API_URL_V3,
    paywallApi: isServer ? apiConfig.PAYWALL_API_URL_SERVER : apiConfig.PAYWALL_API_URL,
    customerDataApi: apiConfig.CUSTOMER_DATA_API_URL,
    mediaApi: isServer ? apiConfig.MEDIA_API_DATA_URL_SERVER : apiConfig.MEDIA_API_DATA_URL,
    mediaApiCropper: isServer ? apiConfig.MEDIA_API_URL_SERVER : apiConfig.MEDIA_API_URL,
    ordersApi: isServer ? apiConfig.ORDERS_API_URL_SERVER : apiConfig.ORDERS_API_URL,
    articleExtraContentApi: isServer ? apiConfig.ARTICLE_EXTRA_CONTENT_API_URL_SERVER : apiConfig.ARTICLE_EXTRA_CONTENT_API_URL,
    loginAppBaseUrl: apiConfig.LOGIN_APP_BASE_URL,
    weatherApi: isServer ? apiConfig.WEATHER_API_URL_SERVER : apiConfig.WEATHER_API_URL,
  };
};

export function getEnv(envType: keyof ReturnType<typeof envs>) {
  return envs(process.server)[envType] || '';
}
